import {postRequest} from '../../../../../middlewares/api/actions';
import {getCalculatedRulesDownloadUrl} from '../../../../../constants/urls';

export const FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_SHOW = 'FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_SHOW';
export const FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_HIDE = 'FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_HIDE';
export const FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_CHANGE = 'FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_CHANGE';
export const FILE_MAPPING_WIZARD_DOWNLOAD_CALC_FIELD_RULES = 'FILE_MAPPING_WIZARD_DOWNLOAD_CALC_FIELD_RULES';

export const showExportCalcRules = () => ({
  type: FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_SHOW
});

export const onHideExportCalcRules = () => ({
  type: FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_HIDE
});

export const changeFileMappingWizardCalcExport= fields => ({
  type: FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_CHANGE,
  fields
});

export const submitFileMappingWizardExportCalcRules = (fileName, tableName, mergedList) => {
  const fileSave = {
    name: `${fileName}.xml`,
    type: "text/plain;charset=utf-8"
  };
  var addedListObj = mergedList.map((item, idx) => ({
    'name' : item.name,
    'originalName': item.originalName,
    'added' : item.added,
    'selected' : item.selected,
    'position' : idx
  }))
  return ({
    ...postRequest(
      FILE_MAPPING_WIZARD_DOWNLOAD_CALC_FIELD_RULES,
      getCalculatedRulesDownloadUrl(tableName),
      addedListObj
    ),
    fileSave
  }) 
} 